import React from 'react';

const Protecting = () => {
    return (
        <>
            <div className='protecting items-center overflow-hidden mx-auto'>
                <div className='md:px-10 px-5 justify-center text-center md:py-60 py-5 max-w-screen-xl mx-auto'>
                    <div className='mx-auto overflow-hidden text-[#fff] max-w-screen-lg'>
                        <h1 className='md:text-5xl py-2 text-xl'>
                            Protecting you from <br /> the dangers of <br /> cyberspace.
                        </h1>
                        <p className='max-w-xl pt-5 justify-center mx-auto text-[#C3CDD3]'>RockSec Group provides advanced cybersecurity solutions to safeguard your business against evolving digital threats. Trust us to secure your operations and protect your data with precision and expertise.</p>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Protecting;